import { render, staticRenderFns } from "./DocumentPortalSetupWelcomeView.vue?vue&type=template&id=5ff80cc2&scoped=true&"
import script from "./DocumentPortalSetupWelcomeView.vue?vue&type=script&setup=true&lang=js&"
export * from "./DocumentPortalSetupWelcomeView.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./DocumentPortalSetupWelcomeView.vue?vue&type=style&index=0&id=5ff80cc2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ff80cc2",
  null
  
)

export default component.exports